/*
 * @Author: wangbaihe
 * @Date: 2023-06-02 10:17:36
 * @LastEditors: wangbaihe
 * @LastEditTime: 2025-04-08 14:42:18
 * @FilePath: \common-mediax\src\apis\MediaCloudSystem\Org.js
 * @Description: MediaCloudSystemOrg 添加机构用户配置中读取有权限的渠道列表接口
 */

import { createAPI } from '@common'
export default {
  // 读取有权限的渠道列表接口
  adminChannels: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0benjo0qfsnjttjpot0npet', 'GET', config),
  copy: (config) => createAPI('customEncryptApiName-1/0nfejby.tztufn0vtfst0dpqz', 'POST', config),

  // 读取已有的角色设置
  getUsersRoles: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0vtfst0spmft', 'GET', config),
  // 保存角色设置
  postUsersRoles: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0vtfst0spmft', 'POST', config),
  // 保存角色设置
  postUsersRolesAdd: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0vtfst0spmft0bee!', 'POST', config),
  // 读角色权限：主界面功能权限
  getAdminPermissionsMain: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0benjo0qfsnjttjpot0nbjo', 'GET', config),
  // 保存角色权限：主界面功能权限
  postAdminPermissionsMain: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0benjo0qfsnjttjpot0nbjo', 'POST', config),
  // 读取有权限的发布渠道列表
  getPermissionsChannels: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0qfsnjttjpot0diboofmt', 'GET', config),
  // 是否需要显示文件夹权限接口
  postAdminPermissionsShowfolder: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0benjo0qfsnjttjpot0tipxgpmefs', 'GET', config),
  // 读取一个机构下的角色列表
  getAdminRoles: (config) => createAPI('customEncryptApiName-1/0f60benjo0spmft', 'GET', config), // 读取一个机构下的角色列表
  // 机构用户同步IM用户
  postMinUsersSync: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0jn0vtfst0tzod', 'GET', config),
  // 机构用户同步IM用户
  getMinUsersProgress: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0jn0vtfst0tzod0qsphsftt', 'GET', config, vConfig),
  // 调用加好友接口，以供移动端通讯录展示
  postAddFriends: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0jn0vtfst0gsjfoet', 'GET', config, {
      neverLoading: true
    }),
  // 重置密码：获得一个随机密码
  // getUsersPasswordRandom: (config) =>
  //   createAPI('customEncryptApiName-1/0w20vtfst0qbttxpse0sboepn', 'GET', config),
  getUsersPasswordRandom: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0vtfst0qbttxpse0sboepn', 'GET', config),
  // 移动用户
  // postUserMove: (config) => createAPI('customEncryptApiName-1/0w20vtfst0npwf', 'POST', config),
  postUserMove: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0vtfst0npwf', 'POST', config),
  // 移动超管用户
  postAdminUserMove: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0vtfst0benjo0npwf', 'POST', config),

  getOrgList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0f60benjo0psht0mjtu', 'get', config),
  getAdminOrgList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0vtfst0benjo0psht0mjtu', 'get', config),
  getUserOrgList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0vtfst0spmft0psht', 'get', config),
  getAppActionPermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0benjo0qfsnjttjpot0bdujpot0dpmvno',
      'get',
      config
    ),
  postAppActionPermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0benjo0qfsnjttjpot0bdujpot0dpmvno',
      'post',
      config
    ),
  getWxActionPermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0benjo0qfsnjttjpot0bdujpot0dpmvno',
      'get',
      config
    ),
  postWxActionPermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0benjo0qfsnjttjpot0bdujpot0dpmvno',
      'post',
      config
    ),
  // 互动运营
  getInteractionActionPermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0benjo0qfsnjttjpot0bdujpot0ojt', 'get', config),
  //小记者人员管理权限查询的接口
  postOperationAuthConfig: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20zpvuiSfqpsu0hfuPqfsbujpoBvuiDpogjh',
      'post',
      config
    ),
  //小记者人员管理权限保存的接口
  postSaveOperationAuth: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20zpvuiSfqpsu0tbwfPqfsbujpoBvui',
      'post',
      config
    ),
  // 社圈
  getAppcircleActionPermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0benjo0qfsnjttjpot0bdujpot0bqqdjsdmf', 'get', config),
  postInteractionActionPermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0benjo0qfsnjttjpot0bdujpot0ojt', 'post', config),
  postAppcircleInteractionActionPermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0benjo0qfsnjttjpot0bdujpot0bqqdjsdmf',
      'post',
      config
    ),

  getPapers: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfs0bmm', 'get', config),
  // 获取专题分组
  getSpecialGroups: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmtqfdjbm0tqfdjbm0hspvq0tfbsdi', 'post', config),
  // 删除用户
  postUserDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0vtfst0efmfuf', 'POST', config),
  // 解锁用户
  postUserUnlock: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0vtfst0vompdl', 'POST', config),
  // 统计分析
  getDataAnalysisActionPermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tubu0benjo0qfsnjttjpot0bdujpot0tubu', 'get', config),
  postDataAnalysisActionPermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tubu0benjo0qfsnjttjpot0bdujpot0tubu', 'post', config),
  // 复制角色
  CopyRole: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0benjo0spmf0dpqz', 'POST', config),
  // 复制角色权限
  CopyPermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0benjo0spmf0qfsnjttjpo0dpqz', 'POST', config),
  // 复制栏目节点权限
  postCopyColumnPermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0benjo0dpmvno0qfsnjttjpo0dpqz', 'POST', config),
  // 复制角色权限
  getDeployOverview: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0efqmpz0pwfswjfx', 'get', config, vConfig),
  // 修改密码发送短信验证码
  postUserSmsSend: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0nbjo0vtfs0tnt0tfoe', 'POST', config),
  // 修改密码短信验证码校对
  postUserSmsCheck: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0nbjo0vtfs0tnt0difdl', 'POST', config),
  // 短信认证修改密码
  postUserSmsPassword: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0nbjo0vtfs0tnt0qbttxpse', 'POST', config),
  // 获取用户授权数
  // 创意作图: cient2-creative-draw
  getUsersAuthorizationcount: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0vtfst0bvuipsj{bujpodpvou', 'get', config),

  // 政情管理-按钮权限列表
  getPoliticalSituationActionPermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0benjo0qfsnjttjpot0bdujpot0ojtDbu', 'get', config),
  // 政情管理-修改按钮权限
  postPoliticalSituationActionPermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0benjo0qfsnjttjpot0bdujpot0ojtDbu', 'post', config),
  // 机构用户树拖拽机构
  postAdminDragOrg: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0benjo0psh', 'post', config),
  // 机构用户树拖拽机构
  postAdminDragRole: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0benjo0spmf', 'post', config),
  // 移除设置用户弹窗中的指定用户s
  postUsersRolesRemove: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0vtfst0spmft0sfnpwf!', 'POST', config),
  // 计算机构下面所有用户数
  getUsersOrgCount: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0vtfst0psh0dpvou', 'get', config),
  // 设置机构管理员
  setOrgAdmin: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0vtfst0psh0benjo', 'POST', config)
}
